export interface IDireccionEstructurada {
    codigo_pais: string,
    codigo_municipio: string,
    codigo_departamento: string,
    direccion?: string,
    zona_rural?: string,
    tipo_via?: string,
    vereda?: string,
    finca_casa?: string,
    tipo_principal?: string,
    numero_principal?: string,
    letra_principal?: string,
    bis_principal?: string,
    letra2_principal?: string,
    cuadrante_principal?: string,
    numero_alterno?: string,
    letra_alterno?: string,
    bis_alterno?: string,
    letra2_alterno?: string,
    numero2_alterno?: string,
    cuadrante_alterno?: string,
    complemento?: Complemento[]
}

export interface Complemento {
    informacion_adicional: string,
    indicacion: string
}

export interface IDireccionKeycloak {
    pais: string;
    departamento: string;
    codeDepartamento: string;
    municipio: string;
    codeMunicipio: string;
    tipoViaPrincipal: string;
    identificacionPrincipal: string;
    letra: string;
    letra2: string;
    bis: string;
    cuadrante: string;
    viaGeneradora: string;
    letraViaGeneradora: string;
    letraViaGeneradora2: string;
    numero: string;
    cuadranteNumero: string;
    tipoComplemento: string;
    complemento: string;
    direccionRural: string;
    direccionInternacional: string;
    zonaRural: number;
    BIS2: string;
}




export function mappearDireccionJSON(DireccionInput: string): IDireccionKeycloak | null {
    if (DireccionInput && DireccionInput[0] && DireccionInput[0] !== null && DireccionInput[0] !== "") {
        const DireccionJson = JSON.parse(DireccionInput);
        const codigo_pais: string = convertirPais(DireccionJson.codigo_pais);
        const complementoDireccion = procesarComplemento(DireccionJson.complemento);
        try {
            const direccionKeycloak: IDireccionKeycloak = {
                pais: codigo_pais || "CO",
                departamento: "", //DireccionJson.departamento,
                codeDepartamento: DireccionJson.codigo_departamento == "11" ? "25" : DireccionJson.codigo_departamento,
                municipio: "", //DireccionJson.municipio,
                codeMunicipio: DireccionJson.codigo_municipio,
                tipoViaPrincipal: DireccionJson.tipo_principal ? DireccionJson.tipo_principal : DireccionJson.tipo_via,
                identificacionPrincipal: DireccionJson.numero_principal,
                letra: DireccionJson.letra_principal || "",
                letra2: DireccionJson.letra2_principal || "",
                bis: DireccionJson.bis_principal || "",
                cuadrante: DireccionJson.cuadrante_principal?.toUpperCase(),
                viaGeneradora: DireccionJson.numero_alterno,
                letraViaGeneradora: DireccionJson.letra_alterno || "",
                letraViaGeneradora2: DireccionJson.letra2_alterno || "",
                numero: DireccionJson.numero2_alterno,
                cuadranteNumero: DireccionJson.cuadrante_alterno?.toUpperCase(),
                tipoComplemento: DireccionJson.complemento && DireccionJson.complemento[0].informacion_adicional ? DireccionJson.complemento[0].informacion_adicional : "",
                complemento: complementoDireccion,
                direccionRural: DireccionJson.zona_rural == "1"? DireccionJson.direccion : "",
                direccionInternacional: DireccionJson.direccionInternacional || "",
                zonaRural: Number(DireccionJson.zona_rural),
                BIS2: DireccionJson.bis_alterno || ""
            };
            return direccionKeycloak;

        } catch (error) {
            if (error instanceof SyntaxError) {
                throw new Error("Invalid JSON format");
            } else {
                throw error;
            }
        }
    }
    return null;
}

export function procesarComplemento(complemento: Complemento[]): string {
    if (complemento) {
        let complementoString = "";
        complemento.forEach(element => {
            complementoString += element.informacion_adicional + " " + element.indicacion + ", ";
        });
        return complementoString;   
    }
    return "";
}

export function mappearDireccion(DireccionJSON: string): IDireccionEstructurada | null {
    if (DireccionJSON !== null) {
        try {
            return JSON.parse(DireccionJSON) as IDireccionEstructurada;
        } catch (error) {
            if (error instanceof SyntaxError) {
                throw new Error("Invalid JSON format");
            } else {
                throw error;
            }
        }
    }
    return null;
}

export function convertirPais(codigoPais: string): string {

    if (codigoPais === "Colombia")  return "CO";
    
    const paises = require('../../../../assets/json/codigosPaises.json');
    paises.forEach(pais => {
        if (pais.nameES === codigoPais) {
            return pais["iso2"];
        }
    });
    return "";
}

